/** Normalize to what we store in JWT / localStorage. */
export function normalizePanelTheme(value) {
  return value === 'light' ? 'light' : 'dark';
}

export function applyUserPanelTheme(value) {
  if (typeof document === 'undefined') return;
  const t = normalizePanelTheme(value);
  document.documentElement.classList.toggle('light-theme', t === 'light');
  try {
    localStorage.setItem('panel-theme', t);
  } catch {
    /* ignore */
  }
}
